var _style, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos_COE-EU-JP",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.7 54.5",
    style: {
      enableBackground: "new 0 0 69.7 54.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#293F85;}\n\t.st2{fill:#FCEA4B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,0h62.6c1.9,0,3.5,1.6,3.5,3.5V51c0,1.9-1.6,3.5-3.5,3.5H3.5C1.6,54.5,0,52.9,0,51V3.5C0,1.6,1.6,0,3.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.3-0.1h63c1.8,0,3.3,1.5,3.3,3.3v41c0,0.6-0.5,1.1-1.1,1.1H1.1c-0.6,0-1.1-0.5-1.1-1.1v-41 C0,1.4,1.5-0.1,3.3-0.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.6,10.8 35,9.8 36.3,10.8 35.8,9.1 37.2,8.1 35.5,8.1 35,6.5 34.4,8.1 32.7,8.1 34.1,9.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "26.5,12.7 27.9,11.7 29.2,12.7 28.7,11.1 30.1,10.1 28.4,10.1 27.9,8.4 27.3,10.1 25.6,10.1 27,11.1  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "22.6,13.6 22.1,15.3 20.4,15.3 21.8,16.3 21.3,17.9 22.6,16.9 24,17.9 23.5,16.3 24.9,15.3 23.2,15.3  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "20.7,24 22.1,25 21.6,23.4 23,22.4 21.3,22.4 20.7,20.7 20.2,22.4 18.5,22.4 19.9,23.4 19.4,25 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "23.2,29.5 22.6,27.9 22.1,29.5 20.4,29.5 21.8,30.5 21.3,32.1 22.6,31.1 24,32.1 23.5,30.5 24.9,29.5  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.4,34.7 27.9,33.1 27.3,34.7 25.6,34.7 27,35.7 26.5,37.4 27.9,36.4 29.2,37.4 28.7,35.7 30.1,34.7  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.5,36.6 35,35 34.4,36.6 32.7,36.6 34.1,37.6 33.6,39.3 35,38.3 36.3,39.3 35.8,37.6 37.2,36.6 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.6,34.7 42.1,33.1 41.6,34.7 39.8,34.7 41.2,35.7 40.7,37.4 42.1,36.4 43.5,37.4 42.9,35.7  44.3,34.7 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.8,29.5 47.3,27.9 46.8,29.5 45.1,29.5 46.5,30.5 45.9,32.1 47.3,31.1 48.7,32.1 48.2,30.5  49.6,29.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "51.4,22.4 49.7,22.4 49.2,20.7 48.7,22.4 46.9,22.4 48.3,23.4 47.8,25 49.2,24 50.6,25 50,23.4 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "45.9,17.9 47.3,16.9 48.7,17.9 48.2,16.3 49.6,15.3 47.8,15.3 47.3,13.6 46.8,15.3 45.1,15.3  46.5,16.3 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.1,8.4 41.6,10.1 39.9,10.1 41.3,11.1 40.7,12.7 42.1,11.7 43.5,12.7 43,11.1 44.4,10.1 42.6,10.1  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.4,47.5H6v2.6c0,0.4,0,0.8-0.2,1.1c-0.1,0.3-0.3,0.5-0.5,0.6c-0.3,0.2-0.6,0.2-1,0.2c-0.4,0-0.8-0.1-1-0.2 c-0.3-0.1-0.5-0.4-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-1.1v-2.6h0.6v2.6c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.2,0.3,0.4,0.4 c0.2,0.1,0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,0.9-0.3s0.3-0.6,0.3-1.1L5.4,47.5C5.4,47.5,5.4,47.5,5.4,47.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,52v-4.5h0.6L9.9,51v-3.5h0.6V52H9.9l-2.4-3.5V52C7.5,52,6.9,52,6.9,52z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,52v-4.5h0.6V52H11.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,49.8c0-0.7,0.2-1.3,0.6-1.7s0.9-0.6,1.5-0.6c0.4,0,0.8,0.1,1.1,0.3s0.6,0.5,0.8,0.8 c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.1,0.9-0.3,1.2c-0.2,0.4-0.4,0.6-0.8,0.8C15.9,52,15.5,52,15.1,52c-0.4,0-0.8-0.1-1.1-0.3 c-0.3-0.2-0.6-0.5-0.8-0.8S13,50.2,13,49.8z M13.6,49.8c0,0.5,0.1,1,0.4,1.3c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5 c0.3-0.3,0.4-0.8,0.4-1.3c0-0.4-0.1-0.7-0.2-1s-0.3-0.5-0.5-0.6c-0.2-0.1-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4 S13.6,49.1,13.6,49.8L13.6,49.8L13.6,49.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,52v-4.5h0.6L21,51v-3.5h0.6V52H21l-2.4-3.5V52H18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.3,52v-4.5h3.2V48h-2.6v1.4h2.5v0.5h-2.5v1.5h2.7V52L24.3,52C24.3,52,24.3,52,24.3,52z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,47.5H32v2.6c0,0.4,0,0.8-0.2,1.1c-0.1,0.3-0.3,0.5-0.5,0.6c-0.3,0.2-0.6,0.2-1,0.2s-0.8-0.1-1-0.2 c-0.3-0.1-0.5-0.4-0.6-0.6c-0.1-0.3-0.2-0.6-0.2-1.1v-2.6h0.6v2.6c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.2,0.3,0.4,0.4 c0.2,0.1,0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.3-0.6,0.3-1.1C31.4,50.1,31.4,47.5,31.4,47.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,52v-4.5h2c0.4,0,0.7,0,0.9,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0.2,0.4,0.2,0.7c0,0.3-0.1,0.6-0.3,0.8 c-0.2,0.2-0.5,0.4-1,0.4c0.2,0.1,0.3,0.1,0.4,0.2c0.2,0.2,0.3,0.4,0.5,0.6l0.8,1.2h-0.7l-0.6-0.9c-0.2-0.3-0.3-0.5-0.4-0.6 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0h-0.7v2L33,52L33,52L33,52z M33.6,49.5h1.3 c0.3,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.1,0.4-0.3s0.1-0.3,0.1-0.4c0-0.2-0.1-0.4-0.2-0.5C35.6,48.1,35.3,48,35,48h-1.4L33.6,49.5 L33.6,49.5L33.6,49.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.3,49.8c0-0.7,0.2-1.3,0.6-1.7c0.4-0.4,0.9-0.6,1.5-0.6c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.5,0.8,0.8 c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.1,0.9-0.3,1.2s-0.4,0.6-0.8,0.8C40.2,52,39.8,52,39.4,52c-0.4,0-0.8-0.1-1.1-0.3 c-0.3-0.2-0.6-0.5-0.8-0.8S37.3,50.2,37.3,49.8z M37.9,49.8c0,0.5,0.1,1,0.4,1.3s0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5 c0.3-0.3,0.4-0.8,0.4-1.3c0-0.4-0.1-0.7-0.2-1s-0.3-0.5-0.5-0.6c-0.2-0.1-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4 C38.1,48.6,37.9,49.1,37.9,49.8L37.9,49.8L37.9,49.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.3,52v-4.5H44c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.4-0.1,0.7-0.4,1c-0.2,0.3-0.7,0.4-1.3,0.4H43V52L42.3,52L42.3,52z M42.9,49.6h1.2c0.4,0,0.7-0.1,0.8-0.2 c0.2-0.1,0.2-0.3,0.2-0.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.3,0-0.6,0h-1.1L42.9,49.6L42.9,49.6L42.9,49.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.5,52v-4.5h3.2V48h-2.6v1.4h2.5v0.5h-2.5v1.5h2.7V52L46.5,52L46.5,52L46.5,52z M47.7,47.2l0.4-0.9h0.7 l-0.7,0.9H47.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,52v-4.5h3.2V48h-2.6v1.4h2.5v0.5h-2.5v1.5H54V52L50.7,52L50.7,52L50.7,52z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.8,52v-4.5h0.6l2.4,3.5v-3.5h0.6V52h-0.6l-2.4-3.5V52H54.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.3,52v-4.5h0.6l2.4,3.5v-3.5h0.6V52h-0.6l-2.4-3.5V52H59.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.9,52v-4.5h3.2V48h-2.6v1.4h2.5v0.5h-2.5v1.5h2.7V52L63.9,52L63.9,52L63.9,52z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuLogo);
export default __webpack_public_path__ + "static/media/EU-logo.88dd4384b04ee3614687d131c051f033.svg";
export { ForwardRef as ReactComponent };